import { CreateRecruitmentForm } from "custom_components/templates/FormTemplate";
import {
    Switch,
    Route,
    Redirect,
    useLocation,
} from "react-router-dom"
import MainTemplate from "custom_components/templates/MainTemplate";
import { useUserPermission } from "custom_hooks/Actions";
import { FullTabulatorTemplate } from "custom_components/templates/TabulatorTemplate";
import { useState } from "react";

import CreateFixedAsset from "./CreateFixedAsset";
import FixedAssetDetail from "./FixedAssetDetail";
// import StaffInfo from "./StaffInfo";

var userCode = ""
var userRole = ""

const path = process.env.REACT_APP_PATH;
const domain = process.env.REACT_APP_DOMAIN

function parseCustomData(dt){
    dt = dt.trim()
    console.log("after trim", dt)
    dt = dt.replaceAll(/[^\B\s+|\s+\Ba-z0-9:",.{}-]/gi, '')
    console.log("after replace", dt)

    dt = JSON.parse(dt)

    console.log("after replace", dt)
   
    // console.log("dt", dt)
   return dt
}

function parseFixedAsset(data) {
    // console.log("data", data)
    let dataForActive = []
    let dataForInactive = []

    try{
        userCode = data[2]
        userRole = data[1]
        data[0].forEach((number, index, array) => {
            let itemDetail = parseCustomData(array[index].itemDetail)
            let issueDetail = parseCustomData(array[index].issueDetail)

            // console.log("item", itemDetail)
            // console.log("issue", issueDetail)

            let obj = {
                no: index+1,
                category: array[index].category,
                subCategory: array[index].subCategory,
                purchaseDate: itemDetail.purchaseDate,
                warrantyDate: itemDetail.warrantyDueDate,
                user: issueDetail.receiver,
                status: array[index].status,
                remark: array[index].remark,
                assetId: array[index].assetId,
                eqNo: itemDetail.equipmentNo,
            }


            dataForActive.push(obj);
        
        })
    }catch(e){
        console.log("error fa",e.message)
    } 
    const parsedData = [dataForActive, dataForInactive]
    return parsedData
}

function FixedAsset({permission}){
    const [redirect, setRedirect] = useState({ allow: false })
    const location = useLocation()
    const tabs = ["Active"];
    const columns = [
        { title: " S/no.", field: "no", headerFilter: "input"},
        {
            title: "Equipment No", field: "eqNo", headerFilter: "input", formatter: "link", formatterParams: {
                labelField: "eqNo",
                urlPrefix: "fa/"
            },
            //hacky way to make tabulator play well with react router
            cellClick: function (e, cell) { 
                e.preventDefault()
                const rowInfo = cell._cell.row.data
                setRedirect({ allow: true, id: rowInfo.assetId }) //here we update state
            }
        },
        { title: "Category", field: "category", headerFilter: "input" },
        { title: "Sub-Category", field: "subCategory", headerFilter: "input" },
        { title: "Purchase Date", field: "purchaseDate", headerFilter: "input" },
        { title: "Warranty Due Date", field: "warrantyDate", headerFilter: "input" },
        { title: "User" , field:"user", headerFilter: "user"},
        { title: "Remark", field: "remark", headerFilter: "input" },
        { title: "Status", field: "status", headerFilter: "input" },
    ]

    return(
        redirect.allow ?
            <Redirect push to={location.pathname+"/"+redirect?.id} />
        :
        <FullTabulatorTemplate 
            permission = {permission}
            fetchURL = {window.location.toString().split(path)[0] + path + "/api/SupportModule/fixedAsset.php?action=getAllFixedAsset"}
            parseFunc = {parseFixedAsset}
            columns = {columns}
            moduleName = {"Fixed Asset"}
            redirect = {redirect}
            tabs={tabs}
            disableWidget = {false}
            from="fa"
        />
    )
}

function FixedAssetContainer(){
    // console.log("permission", sessionStorage.getItem("userPermission"))
    const perm = useUserPermission(33);

    console.log("actual support permission", perm)
    return(
        <MainTemplate content={
            <Switch>
                 {
                    <Route path="/:subdom/:page/create" children={<CreateFixedAsset />} />
                }
                {/*{
                    perm.view ? <Route path="/:subdom/:page/:id/details" children={<EmployeeInfo defaultTab={"Details"} />} /> : null
                }
                {
                    perm.view ? <Route path="/:subdom/:page/:id/cert" children={<EmployeeInfo defaultTab={"Certificate"} />} /> : null
                }*/}
                {
                    <Route path="/:subdom/:page/:id" children={<FixedAssetDetail />} />
                }
                {
                    <Route path="" children={<FixedAsset permission={perm} />} />
                } 
            </Switch>
        }
        />
    )
}

export default FixedAssetContainer